// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import appVersionJson from '~/app-version.json'

export const APP_VERSION = appVersionJson.version
